'use client';
import React, { useEffect, useState } from 'react';
import style from './style.module.scss';
import { MiniTitle } from '@/ui/miniTitle/miniTitle';
import { extractDataFromUrl, useFetch, useFetchClientSide } from '@/hooks';
import Image from 'next/image';
import Link from 'next/link';
import notImage from '../../public/not-image.png';
import { FavoritesSkeleton } from './skeleton/favorites-skeleton';

interface Picture {
  url: string; // или другой нужный вам тип
  alt?: string; // необязательное поле для текста альтернативы
  data: any;
  formats: any;
}

interface Protest {
  wordFromUrl: string;
  link: string;
  id: number;
  title: string;
  createdAt: string; // можно использовать Date, если вы будете парсить
  updatedAt: string; // можно использовать Date, если вы будете парсить
  publishedAt: string; // можно использовать Date, если вы будете парсить
  previewPicture: Picture;
  detailPicture: Picture;
}

export const Favorites = () => {
  const { data, error } = useFetchClientSide(
    process.env.NEXT_PUBLIC_API_URL + '/izbrannyes?populate=*'
  );
  const [detailedData, setDetailedData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (data) {
      setLoading(true);
      const fetchData = async () => {
        try {
          const detailedItems = await Promise.all(
            data.map(async (elem: Protest) => {
              const { wordFromUrl, idFromUrl, resultWordFromUrl } =
                extractDataFromUrl(elem?.link);

              const endpoint = `${process.env.NEXT_PUBLIC_API_URL}/${resultWordFromUrl}/${idFromUrl}?populate=*`;
              const response = await fetch(endpoint);
              const result = await response.json();

              return {
                ...result.data,
                wordFromUrl,
                idFromUrl,
                resultWordFromUrl,
              };
            })
          );

          setDetailedData(detailedItems);
        } catch (error) {
          console.error('Ошибка загрузки данных:', error);
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    }
  }, [data]);

  if (loading) {
    return <FavoritesSkeleton count={8} />;
  }

  if (error || !data) {
    return <p>Произошла ошибка при загрузке данных</p>;
  }
  return (
    <div className={style.favorites}>
      <div className={style.top}>
        <MiniTitle text="Избранное" />
      </div>

      <ul className={style.list}>
        {detailedData?.map((elem: Protest) => {
          return (
            <li key={elem?.id} className={style.element}>
              <Link href={`/${elem?.wordFromUrl}/${elem?.id}`}>
                <Image
                  alt="poster"
                  src={
                    (elem.previewPicture?.formats?.large?.url &&
                      process.env.NEXT_PUBLIC_APP_UPLOAD_URL +
                        elem.previewPicture.formats.large.url) ||
                    (elem.previewPicture?.url &&
                      process.env.NEXT_PUBLIC_APP_UPLOAD_URL +
                        elem.previewPicture.url) ||
                    notImage
                  }
                  width={300}
                  height={199}
                />

                <h3 className={style.title}>{elem?.title}</h3>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
